import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */

/** API */
import XrayFilmTypeApi from 'api/setting/treatments/xray-film-type.api'

/** UTILS || SLICE */
import { submitModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import HeaderCard from 'component/CardCustom/HeaderCard'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

const initStateErrorMessage = {
  XRAY_FILM_TYPE_NAME: ``,
  IS_DUPLICATE_XRAY_FILM_TYPE_NAME: ``,
  XRAY_FILM_TYPE_NAME_STRING_BASE: ``,
  XRAY_FILM_TYPE_NAME_STRING_EMPTY: ``,
  XRAY_FILM_TYPE_NAME_MAXIMUM_LENGTH: ``,
  XRAY_FILM_TYPE_NAME_ANY_REQUIRED: ``,

  XRAY_FILM_TYPE_NAME_EN: ``,
  IS_DUPLICATE_XRAY_FILM_TYPE_NAME_EN: ``,
  XRAY_FILM_TYPE_NAME_EN_STRING_BASE: ``,
  XRAY_FILM_TYPE_NAME_EN_STRING_EMPTY: ``,
  XRAY_FILM_TYPE_NAME_EN_MAXIMUM_LENGTH: ``,
  XRAY_FILM_TYPE_NAME_EN_ANY_REQUIRED: ``
}

export default function XrayFilmTypes() {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [xrayFilmTypes, setXrayFilmTypes] = useState([])

  const [xrayFilmTypeId, setXrayFilmTypeId] = useState(Number)
  const [xrayFilmTypeName, setXrayFilmTypeName] = useState('')
  const [xrayFilmTypeStatus, setXrayFilmTypeStatus] = useState('')
  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  const loadData = async () => {
    try {
      const resp = await XrayFilmTypeApi.findAll({
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setXrayFilmTypes(resp.data)
      } else {
        setXrayFilmTypes([])
      }
    } catch (error) {
      notiError('เกิดข้อผิดพลาด')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  const submit = () => {
    setDisabledSubmit(true)
    if (!xrayFilmTypeName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ XRAY_FILM_TYPE_NAME: t('XRAY_FILM_TYPE.MESSAGE.XRAY_FILM_TYPE_NAME') } })
    }

    dispatch(submitModal())
    XrayFilmTypeApi.create({ xrayFilmTypeName })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('XRAY_FILM_TYPE.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()
          loadData()
          setIsOpen(false)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`XRAY_FILM_TYPE.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`XRAY_FILM_TYPE.MESSAGE.${err.message}`) } })
      })
  }

  const submitEdit = () => {
    setDisabledSubmit(true)
    if (!xrayFilmTypeName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ XRAY_FILM_TYPE_NAME: t(`XRAY_FILM_TYPE.MESSAGE.XRAY_FILM_TYPE_NAME`) } })
    }

    dispatch(submitModal())
    XrayFilmTypeApi.update(xrayFilmTypeId, {
      xrayFilmTypeName,
      status: xrayFilmTypeStatus
    })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`XRAY_FILM_TYPE.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          setIsOpen(false)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`XRAY_FILM_TYPE.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`XRAY_FILM_TYPE.MESSAGE.${err.message}`) } })
      })

  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setXrayFilmTypeId(0)
    setXrayFilmTypeName('')
    setXrayFilmTypeStatus('')
    clearErrorMessage()
    setIsOpen(false)
  }

  const onActive = () => {
    if (id) {
      XrayFilmTypeApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('XRAY_FILM_TYPE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('XRAY_FILM_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = async () => {
    if (id) {
      XrayFilmTypeApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('XRAY_FILM_TYPE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('XRAY_FILM_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { xrayFilmTypeId: id, xrayFilmTypeName: name, status: xrayTypeStatus } = data
    setXrayFilmTypeId(id)
    setXrayFilmTypeName(name)
    setXrayFilmTypeStatus(xrayTypeStatus)
    setIsOpen(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }

  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }

  const headCells = [
    { id: 'no', disablePadding: false, label: t('TABLE.NO') },
    { id: 'xrayFilmTypeName', disablePadding: false, label: t('XRAY_FILM_TYPE.TABLE.CELL.XRAY_FILM_TYPE_NAME') },
    { id: 'status', disablePadding: false, label: t('XRAY_FILM_TYPE.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('XRAY_FILM_TYPE.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { xrayFilmTypeId: id, xrayFilmTypeName: name, updatedBy, updatedAt, status: xrayTypeStatus } = objData
    const statusBtnActive = xrayTypeStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = xrayTypeStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: id,
      id: id,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: name },
        { option: 'STATUS', align: 'center', label: xrayTypeStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.xrayFilmTypeName)
  }

  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`XRAY_FILM_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`XRAY_FILM_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { xrayFilmTypeName: name, status: t(`XRAY_FILM_TYPE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <PageModal
        title={xrayFilmTypeId ? t('XRAY_FILM_TYPE.TITLE_UPDATE') : t('XRAY_FILM_TYPE.TITLE_CREATE')}
        size='XS'
        isOpen={isOpen}
        handleClose={resetForm}
        onCancel={{ onClick: resetForm, title: t('XRAY_FILM_TYPE.BUTTON.CANCEL') }}
        onSubmit={{ onClick: xrayFilmTypeId ? submitEdit : submit, title: t('XRAY_FILM_TYPE.BUTTON.SAVE'), disabled: disabledSubmit }}
      >
        <Box display="flex" flexDirection="column" gap="16px">
          {xrayFilmTypeId ? <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
            <SwitchButton onChange={() => setXrayFilmTypeStatus(xrayFilmTypeStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={xrayFilmTypeStatus === 'ACTIVE' ? true : false} />
          </Box> : ''}
          <TextInput
            onChange={(event) => {
              setXrayFilmTypeName(event.target.value)
              clearErrorMessage()
            }}
            value={xrayFilmTypeName}
            label={t('XRAY_FILM_TYPE.INPUT.XRAY_FILM_TYPE_NAME')}
            helperText={
              errorMessage.XRAY_FILM_TYPE_NAME ||
              errorMessage.IS_DUPLICATE_XRAY_FILM_TYPE_NAME ||
              errorMessage.XRAY_FILM_TYPE_NAME_STRING_BASE ||
              errorMessage.XRAY_FILM_TYPE_NAME_STRING_EMPTY ||
              errorMessage.XRAY_FILM_TYPE_NAME_MAXIMUM_LENGTH ||
              errorMessage.XRAY_FILM_TYPE_NAME_ANY_REQUIRED
            }
            required
          />
        </Box>
      </PageModal>
      <HeaderCard text={t('XRAY_FILM_TYPE.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={2}>
            <TextInput
              label={t('XRAY_FILM_TYPE.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={1}>
            <MainButton
              title={t('INPUT.SEARCH')}
              type='primary'
              variant='contained'
              style={{ width: '120px' }}
              onClick={() => {
                setPage(1)
                loadData()
              }} />

          </Grid>
          <Grid item xs={7} textAlign="right">
            <MainButton title={t('XRAY_FILM_TYPE.BUTTON.ADD')} disabled={permissions.isCreate.disabled} type='primary' variant='contained' onClick={() => setIsOpen(true)} startIcon={<AddCircleIcon />} />
          </Grid>
        </Grid>

        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={xrayFilmTypes.map((val, i) => {
              return renderData(val, i)
            })}
          />
        </Box>
      </Box>
    </Box>
  )
}
